import { createAuthClient } from 'better-auth/react';

export const authClient = createAuthClient({
  basePath: '/api/better-auth',
});

export const { useSession, signIn, signUp, signOut } = authClient;
